<template>
<div>
    <md-dialog :md-active.sync="showDialog" class="dg-filter" :md-click-outside-to-close="clickOutside">
        <md-dialog-title>Add Filters</md-dialog-title>

        <div class="layout-dialog">
            <multiselect v-model="selectedFilterStatus" 
            id="status" :class="(classZindex == 'status') ? 'z-index-top' : ''" 
            label="label" 
            track-by="id" 
            placeholder="Reward Status" 
            :open-direction="'bottom'" 
            :options="filtersStatus" 
            :searchable="false" 
            :internal-search="false" 
            :max-height="170" 
            :show-no-results="false" 
            :custom-label="customLabel" 
            :select-label="''" 
            :deselect-label="''" 
            :selected-label="''" 
            :hide-selected="true"
            @select="setDataFilter('status')">
                <template slot="singleLabel" slot-scope="{ option }">
                    <div>
                        <div class="-label">
                            {{ option.label }}
                        </div>
                        <div class="-delete" @mousedown.prevent.stop="clearAll(option.id, 'status')"><i class="material-icons">close</i></div>
                    </div>
                </template>
            </multiselect>
            <multiselect v-model="selectedFilterType" 
                id="type" :class="(classZindex == 'type') ? 'z-index-top' : ''" 
                label="label" 
                track-by="id" 
                placeholder="Reward Type" 
                :open-direction="'top'" 
                :options="filtersType" 
                :searchable="false" 
                :internal-search="false" 
                :max-height="130" 
                :show-no-results="false" 
                :custom-label="customLabel" 
                :select-label="''" 
                :deselect-label="''" 
                :selected-label="''" 
                :hide-selected="true" 
                @select="setDataFilter('type')">
                <template slot="singleLabel" slot-scope="{ option }">
                    <div>
                        <div class="-label">
                            {{ option.label }}
                        </div>
                        <div class="-delete" @mousedown.prevent.stop="clearAll(option.id, 'type')"><i class="material-icons">close</i></div>
                    </div>
                </template>
            </multiselect>
        </div>

        <md-dialog-actions class="-action">
            <md-button class="md-primary -cancel" @click="onClickCancel()">CLEAR</md-button>
            <md-button class="md-primary -filter" @click="onClickFilter()">FILTER</md-button>
        </md-dialog-actions>
    </md-dialog>
</div>
</template>

<script>
import PricingService from "@/services/pricing";

export default {
    name: "dialogFilter",
    props: ["title"],
    components: {},
    watch: {},
    data() {
        return {
            showDialog: true,
            clickOutside: false,
            selectedFilterStatus: '',
            selectedFilterType: '',
            filtersStatus: [{id:'live', label: "Live"}, {id:'Offline', label: "Offline"}],
            filtersType: [{id:"Internal",label:"Goods of siamwalla"},{id:"External",label:"Non goods of siamwalla"}],
            classZindex: ''
        };
    },
    computed: {},
    methods: {
        clearAll(id, type) {
            if (type == 'type') {
                this.selectedFilterType = [];
            } else{
                this.selectedFilterStatus = [];
            }
        },
        customLabel({ id,label}) {
            return `${label}`
        },
        setDataFilter(selectedOption, id) {
           
        },
        onClickFilter() {
            this.$emit("clickFilter", {status : this.selectedFilterStatus , type : this.selectedFilterType});
        },
        onClickCancel() {
            this.$emit("clickCancel", false);
        }
    },
    beforeDestroy() {}
};
</script>

<style lang="scss">
.dg-filter {
    width: 35%;

    .md-dialog-title.md-title {
        font-size: 18px;
        margin-bottom: 5px;
        padding: 24px 30px 0;
    }

    .dialog-content {
        padding: 20px;
    }

    .layout-dialog {
        padding: 10px 25px 5px 25px;

        .filter-items {
            padding-left: 3px;

            input {
                width: 100%;
                margin: 7px;
                padding-left: 5px;
                padding-right: 5px;
                height: 36px;
                border: 1px solid #ddd;
                border-radius: 5px;
                background: #fff;
            }

            ::placeholder {
                color: #BDBDBD;
                opacity: 1;
            }
        }
    }

    .-action {
        padding: 8px 20px 10px 24px;
        bottom: 0px;
        margin-right: auto;
        margin-left: auto;
        width: 100%;
        justify-content: flex-end;

        .-cancel .md-button-content {
            color: #727272;
        }

        .-filter {
            color: #3f51b5;
        }
    }

    .multiselect {
        .z-index-top {
            z-index: 10;
        }

        margin: 12px 5px 12px 2px;

        .multiselect__single,
        .multiselect__input {
            font-size: 14px;

            div {
                display: flex;
                width: 100%;

                .-delete {
                    width: 5%;

                    .material-icons {
                        font-size: 18px;
                        margin-top: 1px;
                        cursor: pointer;
                        color: gray;
                    }
                }
            }
        }

        .multiselect__tags {
            padding: 8px 30px 0 8px;

            ::placeholder {
                color: #BDBDBD;
                opacity: 1;
            }
        }

        .multiselect__content-wrapper {
            font-size: 14px;
            z-index: 10;
        }

        .multiselect__option {
            min-height: 34px;
            padding: 12px 12px 0px 12px;
        }

        ::-webkit-scrollbar {
            width: 8px;
            height: 8px;
        }
    }
}
</style>
